import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const betterStack = defineConnector({
  identifier: "betterStack",
  name: "Better Stack",
  tagLine: "Uptime monitoring, logging, and incident management",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://uptime\\.betterstack\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In [Better Stack](https://betterstack.com/), go to **My Settings → API tokens** and create a new token.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://uptime.betterstack.com/api/v2/monitors",
  },
});
